'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'badge-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f336';
var svgPathData = 'M256 0c35.9 0 67.8 17 88.1 43.4 33-4.3 67.6 6.2 93 31.6s35.9 60 31.6 93C495 188.2 512 220.1 512 256s-17 67.8-43.4 88.1c4.3 33-6.2 67.6-31.6 93s-60 35.9-93 31.6C323.8 495 291.9 512 256 512s-67.8-17-88.1-43.4c-33 4.3-67.6-6.2-93-31.6s-35.9-60-31.6-93C17 323.8 0 291.9 0 256s17-67.8 43.4-88.1c-4.3-33 6.2-67.6 31.6-93s60-35.9 93-31.6C188.2 17 220.1 0 256 0zm0 48c-24.1 0-45.1 13.6-55.7 33.6l-9.3 17.5-19-5.8c-21.6-6.6-46.1-1.4-63.1 15.7S86.6 150.4 93.2 172l5.8 19-17.5 9.3C61.6 210.9 48 231.9 48 256s13.6 45.1 33.6 55.7l17.5 9.3-5.8 19c-6.6 21.6-1.4 46.1 15.7 63.1s41.5 22.3 63.1 15.7l19-5.8 9.3 17.5c10.6 20 31.6 33.6 55.7 33.6s45.1-13.6 55.7-33.6l9.3-17.5 19 5.8c21.6 6.6 46 1.4 63.1-15.7 17-17 22.3-41.5 15.7-63.1l-5.8-19 17.5-9.3c20-10.6 33.6-31.6 33.6-55.7s-13.6-45.1-33.6-55.7l-17.5-9.3 5.8-19c6.6-21.6 1.4-46.1-15.7-63.1S361.6 86.6 340 93.2l-19 5.8-9.3-17.5C301.1 61.6 280.1 48 256 48zM366.3 178.7L352.2 198.1 249.8 338.9 233 362c-8.8-9.1-30.9-32-66.2-68.6l-16.7-17.3 34.5-33.3c9.5 9.8 23.9 24.7 43.2 44.7l85.6-117.7 14.1-19.4 38.8 28.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBadgeCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;